import { Info } from 'lucide-react';

import { cn } from '@/lib/utils';

const EYEBROW = 'Moving from NearSt';
const TITLE = "You're using Unify at no extra cost";
const BODY =
	'As part of the move to Unify you\'ll see "Unify Pro" on your bill over the summer, but rest assured, you\'re still only paying for your existing NearSt subscription. From September 2026, your plan moves to Unify.';

/**
 * Reassurance card for Variant-C (paying NearSt) retailers mid-migration.
 *
 * These customers sit on the Unify Pro product in Stripe but at their own
 * grandfather price for the first 3 months, so the bill reads "Unify Pro" while
 * they're still only paying their existing NearSt amount — confusing without
 * context. The card explains it rather than rolling back the redesign (NEA-5994).
 *
 * Gated purely on `billing.phase === 'grandfather'` — the value `deriveBillingStatus`
 * sets only for an active sub on a `variantc-3mo-*` custom price. That is exactly
 * "custom pricing in Stripe, not the standard £0/£1/£1 trial or full price": standard
 * migration / evergreen customers never match, and a Variant-C customer drops out of
 * it the moment the grandfather phase rolls onto the £29 upgrade rate (where the "no
 * extra cost" message would no longer be true).
 */
export function MigrationInfoCard({ billing }) {
	if (billing?.phase !== 'grandfather') return null;

	return (
		<div
			className={cn(
				'flex items-start gap-4 rounded-2xl border p-5 shadow-[0_1px_2px_rgba(15,23,42,0.04)]',
				'border-primary/30 bg-primary-soft text-primary-soft-foreground'
			)}
		>
			<div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary/15 text-primary-soft-foreground">
				<Info className="h-5 w-5" />
			</div>
			<div className="min-w-0 flex-1 space-y-1">
				<div className="text-[11px] font-semibold uppercase tracking-[0.14em] opacity-80">{EYEBROW}</div>
				<div className="text-base font-bold">{TITLE}</div>
				<div className="text-sm opacity-90">{BODY}</div>
			</div>
		</div>
	);
}
